import { createContext, useEffect, useState } from "react";
import topSellersService from "../service/topSellersService";
import { withRusticMediaVersion } from "../utils/mediaUrl";
const TopSellersContext = createContext(null);

export function TopSellersProvider({ children }) {
  const [topSellersGroups, setTopSellersGroups] = useState([]);
  const [loading, setLoading] = useState(false);

  const fetchTopSellersGroups = async () => {
    try {
      setLoading(true);
      const data = await topSellersService.getTopSellersGroups();

      setTopSellersGroups(
        Array.isArray(data)
          ? data.map((g) => ({
              name: g.name ?? "",
              categories: g.categories ?? "",
              image: withRusticMediaVersion(g.image ?? null),
            }))
          : [],
      );
    } catch (err) {
      console.error("Error fetching Top Sellers groups:", err);
      setTopSellersGroups([]);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchTopSellersGroups();
  }, []);

  return (
    <TopSellersContext.Provider
      value={{
        topSellersGroups,
        loading,
        refreshTopSellers: fetchTopSellersGroups,
      }}
    >
      {children}
    </TopSellersContext.Provider>
  );
}

export default TopSellersContext;
